<template>
  <div class="option">
    <Head style="margin-bottom: -20px" ref="head" />
    <div class="main">
      <div class="bgImgBox">
        <div class="imgBoxCon">
          <!-- 附加服务 -->
          <span>{{ $fanyi("附加服务").toUpperCase() }}</span>
          <!-- 专业的商品摄影服务 -->
          <h1>{{ $fanyi("专业的商品摄影服务") }}</h1>
          <p>
            <!-- 我们深知在线销售需要专业的图像来确保买家做出购买决定，这与实体店购物可以亲手感受产品质量有所不同。 -->
            {{
              $fanyi(
                "我们深知在线销售需要专业的图像来确保买家做出购买决定，这与实体店购物可以亲手感受产品质量有所不同。"
              )
            }}
            <br /><br />
            <!-- 我们提供专业摄影服务，为您提供最佳商品图片，无论商品类型或复杂程度如何。 -->
            {{
              $fanyi(
                "我们提供专业摄影服务，为您提供最佳商品图片，无论商品类型或复杂程度如何。"
              )
            }}
          </p>
        </div>
        <div class="imgBoxCon"></div>
      </div>
      <div class="Services moudleP">
        <div class="serviceIcon">
          <img
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202510/68f098af49332.svg"
            alt=""
          />
        </div>
        <!-- 成本 -（每产品） -->
        <div class="ServicesH1">{{ $fanyi("成本 -（每产品）") }}</div>
        <div class="ServicesH2">
          <!-- 基础产品摄影费用： -->
          {{ $fanyi("基础产品摄影费用：") }}<b>7</b> {{ $fanyi("元/件") }}
        </div>
      </div>
      <div class="whiteBg">
        <div class="Services moudleP">
          <div class="serviceTitle flex acenter">
            <!-- 免费服务 -->
            <span>{{ $fanyi("免费服务") }}</span>
            <div class="line"></div>
          </div>
          <div>
            <div class="serviceItem">
              <!-- 1、模特人体模型 -->
              <h4 class="serviceItemTitle">{{ $fanyi("1、模特人体模型") }}</h4>
              <p>
                {{
                  $fanyi(
                    "有许多物品，如衣服，仅凭平面照片很难了解其尺寸和整体感觉。使用模特人体模型可以轻松展示诸如西装和背包等物品的尺寸和触感。"
                  )
                }}
              </p>
              <div class="flex marBo60">
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094158108006.png"
                    alt=""
                  />
                </div>
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094206151976.png"
                    alt=""
                  />
                </div>
              </div>
              <!-- 2、熨烫服务 -->
              <h4 class="serviceItemTitle">{{ $fanyi("2、熨烫服务") }}</h4>
              <p>
                {{
                  $fanyi("拍摄完成后，我们可以熨烫衣物并消除可能存在的褶皱。")
                }}
              </p>
              <div class="flex marBo60">
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094214579340.png"
                    alt=""
                  />
                </div>
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094222577958.png"
                    alt=""
                  />
                </div>
              </div>
              <!-- 反光处理 -->
              <h4>{{ $fanyi("反光处理") }}</h4>
              <p>
                {{
                  $fanyi(
                    "珠宝和其他产品在拍摄过程中可能会出现反射。我们将免费修改由于反射造成的光斑。"
                  )
                }}
              </p>
              <div class="flex marBo60">
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094229655489.png"
                    alt=""
                  />
                </div>
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094237948286.png"
                    alt=""
                  />
                </div>
              </div>
              <!-- 4.白色背景处理 -->
              <h4>{{ $fanyi("4.白色背景处理") }}</h4>
              <p>
                {{
                  $fanyi(
                    "我们为在线销售准备了所有带白色背景的图片，如果您需要任何变动，请留言。"
                  )
                }}
              </p>
              <div class="flex marBo60">
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094243258424.png"
                    alt=""
                  />
                </div>
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094250675820.png"
                    alt=""
                  />
                </div>
              </div>
              <!-- 5、照片名称 -->
              <h4>{{ $fanyi("5、照片名称") }}</h4>
              <p style="margin-bottom: 60px;">
                {{ $fanyi("我们将依据产品信息逐一为物品命名，以避免错误。") }}
              </p>
              <!-- 6、添加水印 -->
              <h4>{{ $fanyi("6、添加水印") }}</h4>
              <p>
                {{
                  $fanyi(
                    "如果你愿意，我们可以免费在图片中添加水印，这样如果你将图片上传到网上，就不会被盗图。"
                  )
                }}
              </p>
              <div class="flex marBo60">
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2025101709425788028.png"
                    alt=""
                  />
                </div>
                <div class="imgBox">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094304813012.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Services moudleP">
        <div class="serviceTitle flex acenter" style="margin-bottom: 20px;">
          <!-- 收费服务 -->
          <span>{{ $fanyi("收费服务") }}</span>
          <div class="line"></div>
        </div>
        <p>
          {{
            $fanyi(
              "如果您有其他关于照片的需求，例如搭配的包装、套装、模特等，请与我们联系。"
            )
          }}
        </p>
        <div class="flex marBo60">
          <div class="imgBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094315159819.png"
              alt=""
            />
          </div>
          <div class="imgBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017094322466441.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "../../components/foot/Foot";
// 照片服务静态页：文案走 language.js，由全局 $fanyi 按中/意切换
export default {
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  methods: {
    // 打开在线客服
    openChat() {
      this.$fun.clickJs();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/css/mixin.scss";
.marBo60 {
  margin-bottom: 60px;
}

.main {
  min-width: 1400px;
  // background-color: white;
  padding-bottom: 1px;
  .whiteBg {
    background-color: white;
  }
  .moudleP {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0px 1px;
    .serviceTitle {
      margin-bottom: 60px;

      span {
        font-size: 24px;
        line-height: 1;
      }
      .line {
        flex: 1;
        height: 1px;
        background-color: #b4b4b4;
        margin-left: 21px;
      }
    }
    .serviceItemTitle {
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: 0.015em;
      font-variation-settings: "opsz" auto;
      color: #000000;
    }
    h4 {
      font-size: 18px;
      line-height: 1;
      margin-bottom: 20px;
    }
    p {
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      margin-bottom: 30px;
    }
    .imgBox {
      width: 400px;
      padding: 25px;
      border-radius: 10px;
      border: 1px solid #e3e3e3;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
      background-color: white;
    }
    .imgBox + .imgBox {
      margin-left: 60px;
    }
  }
  .bgImgBox {
    background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251016175848720977.png");
    background-position: 50% 50%;
    background-size: 100% auto;
    height: 560px;
    display: flex;
    justify-content: center;
    align-items: center;
    .imgBoxCon {
      display: flex;
      width: 595px;
      padding: 10px;
      justify-content: center;
      flex-direction: column;
      span {
        font-family: Open Sans;
        font-size: 12px;
        font-weight: 600;
        line-height: 12px;
        letter-spacing: 0.015em;

        font-variation-settings: "opsz" auto;
        color: #ffad00;

        z-index: 0;
        margin-bottom: 32px;
      }
      h1 {
        font-family: Open Sans;
        font-size: 26px;
        font-weight: 600;
        line-height: 26px;
        letter-spacing: 0em;
        font-variation-settings: "opsz" auto;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        text-align: left;
        font-family: Open Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 22px;
        letter-spacing: 0.018000000000000002em;

        font-variation-settings: "opsz" auto;
        color: #ffffff;
      }
    }
  }
  .Services {
    padding-top: 60px;
    .serviceIcon {
      width: 100%;
      @extend .dip;
      margin-bottom: 20px;
      img {
        width: 46px;
        height: 46px;
      }
    }
    .ServicesH1 {
      font-family: Open Sans;
      font-size: 24px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0.015em;

      font-variation-settings: "opsz" auto;
      color: #000000;
      text-align: center;
      margin-bottom: 12px;
    }
    .ServicesH2 {
      font-family: Open Sans;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0.015em;

      font-variation-settings: "opsz" auto;
      color: #000000;
      text-align: center;
      margin-bottom: 60px;
    }
  }
}
</style>
